import { Box, Stack, Typography } from "@mui/material";
import { createSearchParams, useNavigate } from "react-router-dom";
import { Calendar } from "./Calendar";
import { Type } from "./Type";
import { IMySchedulesPortal } from "../../../models/my-schedule-portal";
import { useMemo } from "react";
import { ETasyScheduleTypeCode } from "../model";
import { useTranslation } from "react-i18next";

const TRASNLATION_PATH = "page.schedules.mySchedules.";

const LinkAccessScheduleItem = ({
  data,
  isHistoric,
}: {
  data: IMySchedulesPortal;
  isHistoric: boolean;
}) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const onClickHandler = () => {
    const params = {
      historic: String(isHistoric),
    };

    navigate({
      pathname: `schedule/${data.identifier}`,
      ...(isHistoric && { search: `${createSearchParams(params)}` }),
    });
  };

  const descriptionList = useMemo(() => {
    let displayValue = "";
    if (data.tasyScheduleTypeCode === Number(ETasyScheduleTypeCode.EXAM)) {
      const type = t(TRASNLATION_PATH + `type.${ETasyScheduleTypeCode.EXAM}`);
      const procedure = data.procedureName || "-";
      const scheduleRoom = data.calendarName || "-";

      displayValue = t(TRASNLATION_PATH + "examDescription", {
        type,
        procedure,
        scheduleRoom,
        interpolation: { escapeValue: false },
      });
    } else if (
      data.tasyScheduleTypeCode === Number(ETasyScheduleTypeCode.CONSULTATION)
    ) {
      const type = t(
        TRASNLATION_PATH + `type.${ETasyScheduleTypeCode.CONSULTATION}`,
      );
      const physicianName = data.physicianNameExecute || "-";

      displayValue = t(TRASNLATION_PATH + "consultationDescription", {
        type,
        physicianName,
        interpolation: { escapeValue: false },
      });
    }

    const lines = displayValue.split("\n");

    return lines;
  }, [data, t]);

  return (
    <Stack
      sx={(t) => ({
        flexDirection: "row",
        gap: t.spacing(2),
        padding: t.spacing(2),
        backgroundColor: t.palette.divider,
        borderRadius: t.shape.borderRadius / 2,
      })}
      onClick={onClickHandler}
    >
      <Calendar date={data.calendarStartDate} />
      <Stack
        sx={(t) => ({
          justifyContent: "space-between",
          flexGrow: 1,
          padding: t.spacing(1),
          flex: 1,
        })}
      >
        <Stack
          sx={(t) => ({
            flexDirection: "row",
            justifyContent: "space-between",
            gap: t.spacing(1),
            alignItems: "center",
          })}
        >
          <Box
            sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}
          >
            {descriptionList.map((line, index) => (
              <Typography
                key={index}
                sx={{
                  fontWeight: "500",
                  whiteSpace: "wrap",
                  lineHeight: "1.2",
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>
          {data.tasyScheduleTypeCode && (
            <Type type={data.tasyScheduleTypeCode.toString()} />
          )}
        </Stack>
        <Typography style={{ alignSelf: "flex-end", fontSize: 15 }}>
          {data.pacientName}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default LinkAccessScheduleItem;
